module.exports = __webpack_public_path__ + "img/ell_sd.532e6bf0.png";